export default "__VITE_ASSET__DnmXdsLZ__"